module.exports = __webpack_public_path__ + "static/img/new-2.3eeb21d7.jpg";